import { useEffect } from "react";
import Lenis from "lenis";

/**
 * Global smooth-scroll setup. Instantiated once at app root.
 */
export const useLenis = () => {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.15,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            wheelMultiplier: 1,
            touchMultiplier: 1.2,
        });

        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);

        // Anchor navigation
        const onAnchor = (e) => {
            const link = e.target.closest("a[data-scroll-to]");
            if (!link) return;
            const id = link.getAttribute("data-scroll-to");
            const el = document.getElementById(id);
            if (el) {
                e.preventDefault();
                lenis.scrollTo(el, { offset: -64 });
            }
        };
        document.addEventListener("click", onAnchor);

        return () => {
            document.removeEventListener("click", onAnchor);
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);
};
